module.exports = __webpack_public_path__ + "static/media/sample-motor-vehicle-license.4b663c67.jpg";